module.exports = __webpack_public_path__ + "fonts/KaTeX_Size4-Regular.4ad7c7e.ttf";